import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Curated%20fashion%20lifestyle%20flat%20lay%20with%20linen%20fabric%20textures%20in%20warm%20terracotta%20coral%20and%20sage%20green%20tones%20on%20cream%20backdrop%2C%20soft%20morning%20sunlight%20casting%20gentle%20shadows%2C%20elegant%20Italian%20editorial%20photography%2C%20minimalist%20composition%20with%20designer%20sunglasses%20and%20silk%20scarf%20accents%2C%20airy%20sophisticated%20mood&width=1920&height=1080&seq=hero-bg-v2-2026&orientation=landscape"
          alt="Itaobuy Spreadsheet lifestyle fashion"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1200px] mx-auto px-6 md:px-10 pt-20 pb-10">
        <div className="flex flex-col items-center text-center">
          <p className="text-white/70 text-xs md:text-sm tracking-[0.3em] uppercase mb-6 font-label">
            La più grande piattaforma italiana di conoscenza
          </p>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight max-w-[900px] mb-6">
            Itaobuy Spreadsheet Italiano:
            <br />
            <span className="font-heading italic font-normal">La Guida Definitiva</span> per Trovare
            <br />
            i Migliori Prodotti Online
          </h1>

          <p className="text-white/75 text-base md:text-lg max-w-[650px] mb-10 leading-relaxed">
            Scopri prodotti selezionati, guide dettagliate, confronti prezzi e strategie intelligenti
            per utilizzare Itaobuy Spreadsheet in modo semplice e sicuro.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              itaobuy sheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <Link
              to="/articoli/itaobuy-spreadsheet-guida-completa"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white/15 text-white border border-white/30 font-medium text-sm hover:bg-white/25 transition-all whitespace-nowrap backdrop-blur-sm cursor-pointer"
            >
              Leggi la Guida Completa
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-[800px] w-full">
            {[
              { num: '15,420+', label: 'Prodotti Trovati' },
              { num: '500+', label: 'Categorie' },
              { num: '9', label: 'Guide SEO' },
              { num: '24/7', label: 'Aggiornamenti' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-white">{stat.num}</p>
                <p className="text-white/60 text-xs md:text-sm mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}